// extracted by mini-css-extract-plugin
export var container = "_bt-1";
export var cornerButtonContainer = "_bt-6";
export var disabled = "_bt-2";
export var dragActive = "_bt-3";
export var fileContainer = "_bt-5";
export var hiddenInput = "_bt-4";
export var widthContainer = "_bt-0";